export default () => ({
	inputField: null,

	/**
	 *
	 * @returns {HTMLInputElement}
	 */
	getInputField() {
		if (!this.inputField) {
			this.inputField = this.$root.parentElement.querySelector(
				'input[id^="quantity_"]'
			)

			this.inputField.addEventListener('input', () =>
				this.$dispatch('update-quantity')
			)
		}

		return this.inputField
	},

	handlePlus() {
		if (!this.can_plus) {
			return
		}

		this.getInputField().stepUp(this.step)
		this.$dispatch('update-quantity')
	},

	handleMinus() {
		if (!this.can_minus) {
			return
		}

		this.getInputField().stepDown(this.step)
		this.$dispatch('update-quantity')
	},

	get step() {
		return this.getInputField().getAttribute('step') || 1
	},

	get can_plus() {
		return this.getInputField().valueAsNumber < this.max_input
	},

	get can_minus() {
		return this.getInputField() > this.min_input
	},

	get max_input() {
		return this.getInputField().getAttribute('max') || Number.MAX_SAFE_INTEGER
	},

	get min_input() {
		return this.getInputField().getAttribute('min') || 0
	},

	get should_delete() {
		return this.getInputField().valueAsNumber <= 0
	},

	button: {
		['@mouseenter.once']() {
			this.getInputField()
		},
	},
})
